import { render, staticRenderFns } from "./video-item.vue?vue&type=template&id=c7f7c0e2"
import script from "./video-item.vue?vue&type=script&lang=js"
export * from "./video-item.vue?vue&type=script&lang=js"
import style0 from "./video-item.vue?vue&type=style&index=0&id=c7f7c0e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/app/components/ui/Avatar.vue').default,CBtn: require('/app/components/ui/button/c-btn.vue').default,IconMessage: require('/app/components/icons/IconMessage.vue').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,IconPhoneDialogue: require('/app/components/icons/IconPhoneDialogue.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
